import { useSelector, shallowEqual } from 'react-redux';

const useDoctor = () => useSelector(state => state.webChat.doctor, shallowEqual);

export default useDoctor;
